import React, { useEffect, useState } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const css = {
  viewerMainContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: '#0000008c',
    position: 'fixed',
    top: '0',
    left: '0',
    zIndex: '5000',
  },
  closeViewerButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px',
  },
  closeViewerButton: {
    height: '30px',
    width: '30px',
    fontSize: '20px',
    backgroundColor: 'transparent',
    color: 'white',
    cursor: 'pointer',
  },
  documentContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageViewer: {
    maxWidth: '70%',
    maxHeight: '70%',
  },
  pdfViewer: {
    width: '90%',
    height: '90%',
    position: 'absolute',
    top: '60px',
  },
};

const MAX_VIEW_SIZE = 1.5 * 1024 * 1024; // 2 Mo

const DocumentViewer = ({ file, setIsOpen }) => {
  const [pdfUrl, setPdfUrl] = useState(null);

  const handleClose = () => {
    setIsOpen(false);
    if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    setPdfUrl(null);
  };

  const getImageSrc = () => {
    if (!file?.data) return "";
    return file.data.startsWith("data:image")
        ? file.data
        : `data:image/jpeg;base64,${file.data}`;
  };

  useEffect(async () => {
    if (!file) return;

    // Taille approximative en bytes
    const approxSize = Math.floor((file.data.length * 3) / 4);

    if (approxSize > MAX_VIEW_SIZE) {
      // Fichier trop gros → téléchargement automatique
      const dataUri = file.data.startsWith("data:")
          ? file.data
          : `data:${file.mimeType};base64,${file.data}`;

      const link = document.createElement("a");
      link.href = dataUri;
      link.download = file.name || "document";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Fermer la modale
      setIsOpen(false);
      return;
    }

    // PDF de taille raisonnable → création de Blob pour iframe
    if (file.mimeType.includes("pdf")) {
      const preparePdf = async () => {
        try {
          let blob;
          if (file.data.startsWith("data:application/pdf")) {
            blob = await fetch(file.data).then((r) => r.blob());
          } else {
            const dataUri = `data:application/pdf;base64,${file.data}`;
            blob = await fetch(dataUri).then((r) => r.blob());
          }
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
        } catch (err) {
          console.error("Erreur lors du chargement du PDF :", err);
        }
      };
      await preparePdf();
    }
  }, [file]);

  return (
      <div style={css.viewerMainContainer}>
        <div style={css.closeViewerButtonContainer}>
          <FontAwesomeIcon
              icon={faTimes}
              style={css.closeViewerButton}
              onClick={handleClose}
          />
        </div>

        <div style={css.documentContainer}>
          {file?.mimeType?.includes("image") && getImageSrc() && (
              <img src={getImageSrc()} style={css.imageViewer} alt="document" />
          )}

          {file?.mimeType?.includes("pdf") && pdfUrl && (
              <iframe src={pdfUrl} style={css.pdfViewer} title="PDF Viewer" />
          )}
        </div>
      </div>
  );
};

export default DocumentViewer;
